<template>
  <a @click="showMenu()">
    <baseIcon>
      <menuIcon :icon-color="$vuetify.theme.sz_grafit" />
    </baseIcon>
  </a>
</template>

<script>
import baseIcon from '@/icons/BaseIcon';
import menuIcon from '@/icons/MenuIcon';
export default {
    name: 'MainMenuMobileBtn',
    components: {
        baseIcon,
        menuIcon
    },
    methods: {
        showMenu () {
            this.$store.commit('mainMenu/setActiveMenu', true);
        }
    }
};
</script>

<style scoped></style>
